export const LEFT_MENU = {
    SHOW: 'LEFT_MENU.SHOW',
    TOGGLE: 'LEFT_MENU.TOGGLE'
}